module.exports = __webpack_public_path__ + "static/img/7.727ae3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/news/11.18/7.png
// module id = UU+B
// module chunks = 1